import { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { Spinner } from 'reactstrap';
import moment from 'moment';
import classNames from 'classnames';

// ** Reactstrap Imports

import VerticalBarChart from '../CustomChart/VerticalBarChart';
import CustomDatePicker from '../CustomDatePicker/CustomDatePicker';
import Selection from '../Selection/Selection';
import { getToken } from '../../../utility/AuthService';
import { demographicsListService } from '../../../services/demographicsService';
import { getAllIndustryListService } from '../../../services/industryService';
import { filterTotalEmissionIndustryAndStateService, getTotalRecordedEmissionService } from '../../../services/analyticsServices/advanceAnalyticsService/advanceAnalyticsService';
import { useForm } from 'react-hook-form';

const TotalScopeChart = () => {
    const token = getToken()
    const [isLoading, setLoading] = useState(false)
    const [countryName, setCountryName] = useState()
    const [stateName, setStateName] = useState()
    const [industryName, setIndustryName] = useState()
    const [companySizeName, setCompanySizeName] = useState()
    const [allIndustryList, setAllIndustryList] = useState([])
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [chartData, setchartData] = useState()
    const [countryList, setCountryList] = useState([]);
    const [stateList, setStateList] = useState([]);

    const {
        register,
        reset,
        handleSubmit,
        watch,
        control,
        formState: { errors },
        setValue
    } = useForm();

    const watchCountry = watch("Country")
    const watchState = watch("State")

    const companySizeList = [
        {
            value: "Less than R300,000",
            label: "Less than R300,000"
        },
        {
            value: "R300,000 - 3 mil",
            label: "R300,000 - 3 mil"
        },
        {
            value: "R3 mil - 20 mil",
            label: "R3 mil - 20 mil"
        },
        {
            value: "R20 mil - 50 mil",
            label: "R20 mil - 50 mil"
        },
        {
            value: "R50 mil - 100 mil",
            label: "R50 mil - 100 mil"
        },
        {
            value: "R100 mil +",
            label: "R100 mil +"
        }
    ]

    /**
        * @function getCountryList
        * @param
        * @description get country list using api
    */
    const getCountryList = async () => {
        try {
            const result = await demographicsListService({
                type: 'Country',
                typeId: ""
            });
            if (result?.data?.statusCode === 200) {
                setCountryList(result?.data?.data?.list?.map(item => {
                    return {
                        value: item?._id,
                        label: item?.name
                    }
                }))
            }
        } catch (error) {
            setCountryList([])
            toast.error(error?.response?.data?.message || 'Something went wrong')
        }
    };

    /**
        * @function getStateList
        * @param
        * @description get state list using api
    */
    const getStateList = async () => {
        try {
            const result = await demographicsListService({
                type: 'State',
                typeId: watchCountry?.value
            });
            if (result?.data?.statusCode === 200) {
                setStateList(result?.data?.data?.list?.map(item => {
                    return {
                        value: item?._id,
                        label: item?.name
                    }
                }))
            }
        } catch (error) {
            setStateList([])
            toast.error(error?.response?.data?.message || 'Something went wrong')
        }
    };

    useEffect(() => {
        getCountryList()
    }, []);

    useEffect(() => {
        setStateName()
        setValue("State", null)
        if (watchCountry?.value) {
            getStateList()
        }
    }, [watchCountry]);

    /**
        * @function fetchIndustryData
        * @param
        * @description to get all indistry list
    */
    const fetchIndustryData = async () => {
        try {
            const result = await getAllIndustryListService({
                token,
            });
            if (result?.data?.statusCode === 200) {
                setLoading(false)
                setAllIndustryList(result?.data?.data?.list?.map((item) => {
                    return {
                        value: item?._id,
                        label: item?.name
                    }
                }))
            } else {
                setLoading(false)
                setAllIndustryList([])
                toast.error(result?.response?.data?.message || 'Something went wrong')
            }
        } catch (error) {
            setLoading(false)
            setAllIndustryList([])
            toast.error(error?.response?.data?.message || 'Something went wrong')
        }
    }

    /**
        * @function getTotalRecordedEmissionDataService
        * @param
        * @description to get chart data
    */
    const getTotalRecordedEmissionDataService = async () => {
        try {
            setLoading(true)
            const result = await getTotalRecordedEmissionService({
                token
            });
            if (result?.data?.statusCode === 200) {
                setchartData(result?.data?.data)
                setLoading(false)
            } else {
                setLoading(false)
                setchartData()
                toast.error(result?.response?.data?.message || 'Something went wrong')
            }
        } catch (error) {
            setLoading(false)
            setchartData()
            toast.error(error?.response?.data?.message || 'Something went wrong')
        }
    }

    /**
        * @function getfilterEmissionService
        * @param
        * @description to get filter data
    */
    const getfilterTotalEmissionService = async () => {
        try {
            setLoading(true)
            const result = await filterTotalEmissionIndustryAndStateService({
                token,
                country: watchCountry?.label || '',
                state: watchState?.label || '',
                industry: industryName?.value || '',
                companySize: companySizeName?.value || '',
                fromDate: startDate ? moment(startDate).format('YYYY-MM-DD') : '',
                toDate: endDate ? moment(endDate).format('YYYY-MM-DD') : '',
            });
            if (result?.data?.statusCode === 200) {
                setchartData(result?.data?.data)
                setLoading(false)
            } else {
                setLoading(false)
                setchartData()
                toast.error(result?.response?.data?.message || 'Something went wrong')
            }
        } catch (error) {
            setLoading(false)
            setchartData()
            toast.error(error?.response?.data?.message || 'Something went wrong')
        }
    }

    useEffect(() => {
        fetchIndustryData()
    }, []);

    useEffect(() => {
        if (watchCountry || watchState || industryName || companySizeName || startDate || endDate) {
            getfilterTotalEmissionService()
        } else {
            getTotalRecordedEmissionDataService()
        }
    }, [watchCountry, watchState, industryName, companySizeName, startDate, endDate]);

    const VarticalBarData2 = {
        labels: ["Total Scope 1 Emissions", "Total Scope 2 Emissions"],
        datasets: [
            {
                data: chartData ? [chartData?.emissionScope1Total, chartData?.emissionScope2Total] : [],
                maxBarThickness: 60,
                backgroundColor: ["#009EDB"],
                hoverBackgroundColor: ["#009EDB"],
                borderRadius: 1
            }
        ]
    };

    const VarticalBarOption = {
        maintainAspectRatio: false,
        scales: {
            x: {
                grid: {
                    display: false,
                },
                border: {
                    display: false
                }
            },
            y: {
                ticks: {
                    display: true
                },
                border: {
                    display: false
                },
                grid: {
                    drawBorder: false
                }
            },
            xAxes: [
                {
                    gridLines: {
                        display: false
                    },
                    barPercentage: 0.5,
                    barThickness: 6,
                    maxBarThickness: 8,
                    minBarLength: 2
                }
            ],
            yAxes: [
                {
                    gridLines: {
                        display: false
                    }
                }
            ]
        },
        plugins: {
            legend: {
                display: false
            },
            datalabels: {
                anchor: 'end',
                align: 'start',
                color: "white",
                display: function (context) {
                    return context.dataset.data[context.dataIndex] > 0;
                },
                font: {
                    weight: "bold",
                },
                formatter: (value) => {
                    return parseInt(value)
                }
            }
        },
        pointLabelFontFamily: "Quadon Extra Bold",
        scaleFontFamily: "Quadon Extra Bold"
    };

    return <>
        <div className={'px-2 py-1'}>
            <h3 className='mt-4'><strong>Total Scope 1 and Scope 2 Emissions measured</strong></h3>
            <div className='d-flex flex-md-wrap flex-column flex-md-row justify-content-between align-items-center'>
                <div className=''>
                    <Selection className={'w-100'} options={countryList} title={'Country'} control={control} name={'Country'} setWatchValue={setCountryName} styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            width: '250px'
                        }),
                    }} />
                </div>
                <div className=''>
                    <Selection className={'w-100'} options={stateList} title={'State'} control={control} name={'State'} setWatchValue={setStateName} styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            width: '250px'
                        }),
                    }} />
                </div>
                <div className=''>
                    <Selection className={'w-100'} options={allIndustryList} title={'Industry'} name={'Industry'} setWatchValue={setIndustryName} styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            width: '250px'
                        }),
                    }} />
                </div>
                <div className=''>
                    <Selection className={'w-100'} options={companySizeList} title={'Company Size'} name={'CompanySize'} setWatchValue={setCompanySizeName} styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            width: '250px'
                        }),
                    }} />
                </div>

                <div className='d-flex flex-column flex-md-row align-items-center'>
                    <div className='me-2 mb-2 mb-md-0'>
                        <CustomDatePicker startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />
                    </div>
                </div>
            </div>
        </div>
        {isLoading && <div className='text-center h-100'><Spinner></Spinner></div>}
        {!isLoading && <>
            <div className={classNames('col-12 p-2', {
                'd-none': isLoading
            })}>
                <VerticalBarChart data={VarticalBarData2} options={VarticalBarOption} />
            </div>
        </>}
    </>
};

export default TotalScopeChart;